export const CAMPAIGN_CTA_CONSTANTS = {
    pricePlaceholder: '{price}',
};
